import { LoadingLayer, useSetLoading, useIsLoading } from './LoadingLayer';
import './LoadingLayer.scss';

export default LoadingLayer;
export { useSetLoading, useIsLoading };
